import { gql } from 'graphql-tag';

export const GET_DOCKET_FILTER_DEVICES = gql`
  query getPosDevices {
    devices {
      id
      name
      mode
    }
  }
`;

export const GET_DOCKET_FILTER_SECTIONS = gql`
  query getSectionsByStore($storeId: ID!) {
    sectionsByStore(storeId: $storeId) {
      id
      name
    }
  }
`;
